import { Injectable } from '@angular/core';
import { defer, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileDownloadService {
  public downloadFile(
    url: string,
    fileName: string,
    contentType: string,
    contentMD5: string,
  ): void {
    const mergedHeaders = {
      'Content-Type': contentType,
      'Content-MD5': contentMD5,
    };
    const fetchOptions: RequestInit = {
      headers: mergedHeaders,
    };
    fetch(url, fetchOptions)
      .then((res) => res.blob())
      .then((blob) => {
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = fileName || 'archivo';
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(downloadUrl);
          document.body.removeChild(a);
        }, 100);
      });
  }

  public async getFile(
    url: string,
    fileName: string,
    contentType: string,
    contentMD5: string,
  ): Promise<File> {
    const fetchOptions: RequestInit = {
      headers: {
        'Content-Type': contentType,
        'Content-MD5': contentMD5,
      },
    };
    try {
      const response = await fetch(url, fetchOptions);
      const blob = await response.blob();
      return new File([blob], fileName || 'archivo', { type: contentType });
    } catch (error) {
      throw error;
    }
  }

  public getFileFromUrl(
    url: string,
    fileName: string,
    contentType: string,
    contentMD5: string,
  ): Promise<File> {
    const mergedHeaders = {
      'Content-Type': contentType,
      'Content-MD5': contentMD5,
    };
    const fetchOptions: RequestInit = {
      headers: mergedHeaders,
    };
    return fetch(url, fetchOptions)
      .then((res) => res.blob())
      .then((blob) => {
        return new File([blob], fileName || 'archivo', { type: contentType });
      })
      .catch((error) => {
        throw error;
      });
  }

  public getFileFromUrlAlternal(
    url: string,
    fileName: string,
    contentType: string,
    contentMD5: string,
  ): Observable<File> {
    const mergedHeaders = {
      'Content-Type': contentType,
      'Content-MD5': contentMD5,
    };
    const fetchOptions: RequestInit = {
      headers: mergedHeaders,
    };
    return defer(() =>
      fetch(url, fetchOptions)
        .then((res) => res.blob())
        .then((blob) => {
          return new File([blob], fileName || 'archivo', { type: contentType });
        }),
    );
  }
}
